import {type ComponentPropsWithoutRef, type ReactNode, forwardRef} from "react"
import styles from "./Checkbox.module.css"

interface CheckboxProps extends ComponentPropsWithoutRef<"input"> {
    children?: ReactNode
    disabled?: boolean
    checked?: boolean
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
    ({className, children, disabled, checked, ...props}, ref) => {
        return (
            <label
                className={`${styles["checkbox-wrapper"]} ${
                    disabled ? styles.disabled : ""
                } ${className}`}
            >
                <input
                    ref={ref}
                    type="checkbox"
                    className={styles.checkbox}
                    disabled={disabled}
                    checked={checked}
                    {...props}
                />
                {children}
            </label>
        )
    }
)

Checkbox.displayName = "Checkbox"
